import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import { useTheme } from '../contexts/ThemeContext';
import { THEMES, THEME_COLORS } from './Constants';

export default function Toast() {
    const { notification } = useNotification();
    const { themeColors } = useTheme();
    const safeThemeColors = themeColors || THEME_COLORS[THEMES.BLUE];

    if (!notification) return null;

    const isSuccess = notification.type === 'success';
    
    // 🎨 Styles dynamiques basés sur le thème
    const toastStyle = {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '15px 25px',
        backgroundColor: isSuccess ? safeThemeColors.success : safeThemeColors.danger,
        color: safeThemeColors.textSecondary,
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        zIndex: 2000, // Assurez-vous qu'il est au-dessus de tout
        fontWeight: 'bold',
        fontSize: '1em',
        transition: 'opacity 0.3s ease-in-out',
        opacity: 1,
    };

    const icon = isSuccess ? '✅' : '❌';

    return (
        <div style={toastStyle}>
            {icon} {notification.message}
        </div>
    );
}